import Component, { mixins } from 'vue-class-component'
import { ProductApiModel } from '@/interfaces/ProductApiModel'
import { SummarySection } from '@/interfaces/SummarySection'
import { ModelValidator } from './ModelValidator'
import { PriceCalculator } from './PriceCalculator'
import lodash from 'lodash'

@Component
export class ModifiedModels extends mixins(ModelValidator, PriceCalculator) {
  public modifiedModels: Array<{ model: ProductApiModel; price: number | undefined; summarySections: Array<SummarySection> }> = []

  public async addModifiedModel(newModel: ProductApiModel, getPriceAndSummary: boolean, validate = true) {
    if (validate) {
      this.validateAModelAndUpdate(newModel)
    }

    const modelWithPrice = {
      model: newModel,
      price: undefined as number | undefined,
      summarySections: [] as SummarySection[]
    }

    this.modifiedModels.push(modelWithPrice)
    this.modifiedModels.sort((a, b) => a.model.seq - b.model.seq)

    if (getPriceAndSummary) {
      const priceSections = await this.calculatePrice(newModel)

      const price = lodash.sumBy(priceSections, 'totalPrice')

      modelWithPrice.price = price
      modelWithPrice.summarySections = priceSections
    }
  }
}
